var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.record)?_c('div',[_c('span',[_vm._v("Class: "),_c('strong',[_vm._v(_vm._s(_vm.record.class.class))])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }